"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlledModal_1 = __importDefault(require("./ControlledModal"));
exports.Modal = ({ children }) => {
    const [options, setOptions] = react_1.useState({});
    const openModal = react_1.useCallback((newOptions) => {
        setOptions(newOptions);
    }, []);
    const closeModal = react_1.useCallback(() => {
        setOptions({});
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children(openModal),
        Boolean(options.body) && (react_1.default.createElement(ControlledModal_1.default, { fullSize: options.fullSize, title: options.title, onClose: closeModal }, typeof options.body === "function" ? options.body(closeModal) : options.body))));
};
exports.default = exports.Modal;
//# sourceMappingURL=Modal.js.map